// extracted by mini-css-extract-plugin
export var details = "project-details-module--details--1tNzN";
export var htmlSection = "project-details-module--htmlSection--2eFk0";
export var featured = "project-details-module--featured--3OUDF";